import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=50b6986c&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b6986c",
  null
  
)

export default component.exports